module.exports = __webpack_public_path__ + "static/media/wiper-blades-red.ad002e6b.svg";